import {yup} from 'libs/yup'

// ChildcareInfoForm（育休情報入力）の共通項目スキーマ
// 帳票固有項目（leaveDays / extended* / finished* など）は R5xx 側が担当するため含めない
export const schema = yup.object({
  childcareDatum: yup.object({
    employeeDependentId: yup.string().notRequired(),
    startedOn: yup.string().required().dateFormat().label('育児休業等開始年月日'),
    expectedFinishedOn: yup.string().notRequired().dateFormat().label('育児休業等終了（予定）年月日'),
    expectedBirthOn: yup.string().notRequired().dateFormat().label('出産予定日'),
    addToLeaveOfAbsence: yup.boolean().notRequired().label('休職情報に追加する'),
  }),
  childcareChildDatum: yup.object({
    firstName: yup.string().notRequired().max(32).label('名'),
    lastName: yup.string().notRequired().max(32).label('姓'),
    firstNameKana: yup.string().notRequired().zenkakuKatakanaWithSpace().max(32).label('名（カナ）'),
    lastNameKana: yup.string().notRequired().zenkakuKatakanaWithSpace().max(32).label('姓（カナ）'),
    birthDate: yup.string().required().dateFormat().label('生年月日（出産年月日）'),
    relation: yup.mixed<'real' | 'other'>().notRequired().oneOf(['real', 'other']).label('区分'),
    parentingStartedDate: yup.string().notRequired().dateFormat().label('養育開始年月日（実子以外）'),
    addSupport: yup.boolean().notRequired().label('社会保険の被扶養者に追加する'),
  }),
})

export type Schema = yup.InferType<typeof schema>
